<template>
    <div>
        <v-menu
            offset-y
            min-width="auto"
            v-model="menu"
            :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    outlined
                    hide-details
                    readonly
                    clearable
                    append-icon="access_time"
                    :value="timeRangeText"
                    :height="height"
                    :placeholder="$t('placeholder.timeRange')"
                    :style="{ minWidth: '280px' }"
                    v-on="on"
                    v-bind="attrs"
                    @click:clear="onTimeRangeClear"/>
            </template>

            <v-card>
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <v-time-picker
                                v-model="startTime"
                                format="24hr"
                                :color="color"
                                scrollable
                                @change="updateTime(0, $event)"/>
                        </v-col>
                        <v-col cols="6">
                            <v-time-picker
                                v-model="endTime"
                                format="24hr"
                                :color="color"
                                scrollable
                                @change="updateTime(1, $event)"/>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'TimeRangeField',

    props: {
        value: {
            type: Array,
            default: () => []
        },

        color: {
            type: String,
            default: 'primary'
        },

        height: {
            type: String,
            default: '40px'
        }
    },

    data () {
        return {
            menu: false
        }
    },

    computed: {
        startTime: {
            get () {
                return this.value[0] ? this.$util.getHHSSDateFormat(this.value[0]) : null
            },
            set (time) {
                this.updateTime(0, time)
            }
        },

        endTime: {
            get () {
                return this.value[1] ? this.$util.getHHSSDateFormat(this.value[1]) : null
            },
            set (time) {
                this.updateTime(1, time)
            }
        },

        timeRangeText () {
            if (!this.value.length) return ''
            return this.startTime && this.endTime ? `${this.startTime} ~ ${this.endTime}` : ''
        }
    },

    methods: {
        updateTime (index, timeString) {
            if (!timeString) return

            const date = new Date()
            const [hours, minutes] = timeString.split(':').map(Number)
            date.setHours(hours, minutes, 0, 0)

            const newValue = [...this.value]
            newValue[index] = date

            this.$emit('input', newValue)
            if (newValue[0] && newValue[1]) {
                this.menu = false
                this.$emit('change', newValue)
            }
        },

        onTimeRangeClear () {
            this.$emit('input', [])
            this.$emit('change', [])
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
